
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import Step1 from "@/components/Singularity/Step1/Step1.vue";
import SingularityLeftPanelNew from "@/components/Singularity/SingularityLeftPanelNew.vue";
import TopNavBuilder from "@/components/Singularity/TopNav/TopNavBuilder.vue";
import SingularityDebugPanel from "@/components/Singularity/SingularityDebugPanel.vue";
import SingularityCanvas from "./SingularityCanvas/SingularityCanvas.vue";
import WPPageManagerNew from "@/components/Singularity/WPPageManager/WPPageManagerNew.vue";

@Component({
  components: {
    Step1,
    SingularityCanvas,
    SingularityLeftPanelNew,
    TopNavBuilder,
    SingularityDebugPanel,
    WPPageManagerNew
  }
})
export default class Singularity extends Vue {
  get singularityUiState() {
    return singularityStore.singularityUiState;
  }

  get isFullWidthState() {
    return (
      this.singularityUiState.singularityLeftPanel === "page_manager" ||
      this.singularityUiState.singularityRightPanel === "step1" ||
      this.singularityUiState.singularityLeftPanel === "publish"
    );
  }

  get classes() {
    return {
      "singularity--builder": !this.isFullWidthState,
      "singularity--full-width": this.isFullWidthState,
      [this.singularityUiState.singularityLeftPanel
        ? `singularity--${this.singularityUiState.singularityLeftPanel}`
        : ""]: true
    };
  }
}
